import { ToastProvider } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';
import Workspaces from './domains/workspaces';

/**
 * Root component of the Workspaces application.
 * Mounted by the Core Shell under <Route path="workspaces/*">.
 * Also usable standalone via main.jsx.
 */
const WorkspacesApp = () => {
  const { ready, t } = useTranslation('workspaces');

  if (!ready) {
    return (
      <div className="flex flex-1 items-center justify-center text-sm text-content-muted">
        {t('common.loading')}
      </div>
    );
  }

  return (
    <ToastProvider
      config={{
        position: 'top-right',
        defaultDuration: 4000,
        defaultMaxWidth: '480px',
        defaultMinWidth: '320px',
      }}
    >
      <div className="flex h-full flex-1 flex-col overflow-hidden">
        <Workspaces />
      </div>
    </ToastProvider>
  );
};

export default WorkspacesApp;
